/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type { IntlService } from "ember-intl";
import journalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import MammographyDeclaredJournalEvent from "parog-web/models/mammography-declared-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export default class MammographyEditionFormComponent extends journalEventBasedComponent {
  static fullComponentId = "mammography-and-mri/edition-form";
  static journalEventClass = MammographyDeclaredJournalEvent;
  static forcDisplayName = "Mammographie ou IRM";

  @service declare session: SemeiaSessionService;
  @service declare intl: IntlService;

  journalEventProperties = ["occurredAt", "examType", "acrScore", "comments"];

  get validations() {
    return this.journalEventClass.validations(this.intl);
  }

  retrieveModel() {
    const model = super.retrieveModel();
    model.occurredAt = model.occurredAt || new Date();
    model.examType = model.examType || "mri";
    return model;
  }

  get toastMessage() {
    return this.session.patient
      ? {
          message: "Votre déclaration a bien été prise en compte.",
          title: this.intl.t(
            `mammography-exam.type.${this.changeset.get("examType")}`
          )
        }
      : super.toastMessage;
  }
}
